/**
 * โหมดมืด/สว่างของธีม glass — logic ล้วน (node --test)
 * ลำดับ: ผู้ใช้เลือกเอง (localStorage oc-scheme) > มือถือตั้งมืด > เวลาไทย 18:00–05:59 = มืด
 * inline script ใน index.html ทำซ้ำแบบ ES5 — แก้ที่หนึ่งต้องแก้อีกที่
 */
export type ColorScheme = 'light' | 'dark'
export const SCHEME_STORAGE_KEY = 'oc-scheme'

export function parseScheme(v: unknown): ColorScheme | null {
  return v === 'light' || v === 'dark' ? v : null
}

export function bangkokHour(nowMs: number): number {
  return new Date(nowMs + 7 * 3600_000).getUTCHours()
}

export function isNightHour(h: number): boolean {
  return h >= 18 || h < 6
}

export function resolveScheme(i: { user: ColorScheme | null; deviceDark: boolean; hour: number }): ColorScheme {
  if (i.user) return i.user
  if (i.deviceDark) return 'dark'
  return isNightHour(i.hour) ? 'dark' : 'light'
}
